import React from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Select,
} from '@chakra-ui/react';
import { SaktiAccessCodeFilters } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiAccessCodeFilterBarProps {
  filters: SaktiAccessCodeFilters;
  onFiltersChange: (nextFilters: SaktiAccessCodeFilters) => void;
  onApply: () => void;
  loading?: boolean;
}

const SaktiAccessCodeFilterBar: React.FC<SaktiAccessCodeFilterBarProps> = ({
  filters,
  onFiltersChange,
  onApply,
  loading = false,
}) => {
  const updateFilter = (changes: Partial<SaktiAccessCodeFilters>) => {
    onFiltersChange({
      ...filters,
      ...changes,
    });
  };

  return (
    <Box
      bg="white"
      borderRadius={SAKTI_UI_SIZE.cardRadius}
      p={SAKTI_UI_SIZE.cardPadding}
      borderWidth="1px"
      borderColor="gray.200"
    >
      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', xl: '1fr 1fr 1fr 1fr auto' }}
        gap={SAKTI_UI_SIZE.filterGridGap}
      >
        <FormControl>
          <FormLabel fontSize={SAKTI_UI_SIZE.filterLabel} color="gray.600" mb={1}>
            STATUS
          </FormLabel>
          <Select
            size="sm"
            h={SAKTI_UI_SIZE.controlHeight}
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            value={filters.status || ''}
            onChange={(e) => updateFilter({ status: e.target.value })}
          >
            <option value="">SEMUA STATUS</option>
            <option value="PENDING">PENDING</option>
            <option value="USED">USED</option>
            <option value="EXPIRED">EXPIRED</option>
            <option value="CANCELLED">CANCELLED</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel fontSize={SAKTI_UI_SIZE.filterLabel} color="gray.600" mb={1}>
            NIP KARYAWAN
          </FormLabel>
          <Input
            size="sm"
            h={SAKTI_UI_SIZE.controlHeight}
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            placeholder="Filter NIP"
            value={filters.nip || ''}
            onChange={(e) => updateFilter({ nip: e.target.value })}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize={SAKTI_UI_SIZE.filterLabel} color="gray.600" mb={1}>
            DARI TANGGAL
          </FormLabel>
          <Input
            size="sm"
            h={SAKTI_UI_SIZE.controlHeight}
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            type="date"
            value={filters.date_from || ''}
            onChange={(e) => updateFilter({ date_from: e.target.value })}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize={SAKTI_UI_SIZE.filterLabel} color="gray.600" mb={1}>
            SAMPAI TANGGAL
          </FormLabel>
          <Input
            size="sm"
            h={SAKTI_UI_SIZE.controlHeight}
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            type="date"
            value={filters.date_to || ''}
            onChange={(e) => updateFilter({ date_to: e.target.value })}
          />
        </FormControl>

        <Button
          alignSelf="end"
          size="sm"
          h={SAKTI_UI_SIZE.controlHeight}
          w={{ base: 'full', xl: 'auto' }}
          px={5}
          isLoading={loading}
          loadingText="Loading"
          onClick={onApply}
          bg="customGreen.500"
          _hover={{ bg: 'customGreen.600' }}
          color="white"
          mt={{ base: 2, xl: 0 }}
        >
          Apply Filter
        </Button>
      </Grid>
    </Box>
  );
};

export default SaktiAccessCodeFilterBar;
